<section class="PromoSmallSlider" *ngIf="items.length > 0">
	<div class="uk-flex uk-flex-between uk-flex-bottom uk-margin-medium-bottom">
		<h2 class="Heading--marginLeft uk-margin-remove-bottom">Акции</h2>
		<div class="Heading--marginRight uk-h2 uk-margin-remove-bottom">
			<span class="uk-text-primary">{{items.length}} </span
			><span>предложений </span
			><span class="uk-text-primary">{{filterService.activeTargetAudience ? filterService.activeTargetAudience.name : 'для Каждого'}}</span
			><span class="uk-text-primary">{{filterService.activeActivity ? ' ' + filterService.activeActivity.name : ''}}</span>
		</div>
	</div>

	<div class="uk-position-relative uk-slider" uk-slider="finite: true">
		<div class="uk-grid">
			<div class="PromoSmallSlider_Prev uk-width-auto">
				<div class="uk-width-1-1 uk-height-1-1 uk-position-relative">
					<a class="SliderArrow SliderArrow--left uk-position-top-left" href="#" uk-slider-item="previous">
						<span class="IconItem IconItem--arrowLeft">
							<img src="/assets/img/icon/arrow-left.svg" uk-svg>
						</span>
					</a>
				</div>
			</div>

			<div class="PromoSmallSlider_Container uk-width-expand">
				<div class="uk-slider-container">
					<ul class="uk-slider-items uk-child-width-1-2@l uk-grid">
						<li *ngFor="let item of items" class="PromoSmallSlider_Slide">
							<a [href]="item.link" class="PromoSmallSlider_Slide_Container" target="_blank">
								<span class="PromoSmallSlider_Slide_Img uk-background-cover"
									[style.background-image]="item.featured_media_url ? 'url(' + item.featured_media_url + ')' : 'none'"
								></span>
								<span class="PromoSmallSlider_Slide_Title">{{ item.title.rendered }}</span>
								<span class="uk-link">Подробнее</span>
							</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="PromoSmallSlider_Next uk-width-auto">
				<div class="uk-width-1-1 uk-height-1-1 uk-position-relative">
					<a class="SliderArrow SliderArrow--right uk-position-top-right" href="#" uk-slider-item="next">
						<span class="IconItem IconItem--arrowRight">
							<img src="/assets/img/icon/arrow-right.svg" uk-svg>
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</section>
